import React, { useState, useEffect } from 'react';
import './Clock.css';

const Clock = ({ city, offset, customClass }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const tick = () => {
      setTime(new Date());
    };

    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const getCityTime = (date, offset) => {
    const utc = date.getTime() + date.getTimezoneOffset() * 60000;
    const cityTime = new Date(utc + 3600000 * offset);
    return cityTime;
  };

  const cityTime = getCityTime(time, offset);
  const hours = cityTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }).split(':')[0];
  const minutes = cityTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }).split(':')[1];
  const seconds = cityTime.toLocaleTimeString([], { second: '2-digit' });

  return (
    <div className={`clock ${customClass}`}>
      <div className="city">{city}</div>
      <div className="time">
        <span className="hours">{hours}</span>
        :
        <span className="minutes">{minutes}</span>
        :<span className="seconds">{seconds}</span>
      </div>
    </div>
  );
};

export default Clock;
